import React from 'react'
import { useIntl } from 'react-intl'
import CaptionTextBlock from '../TextBlocks/CaptionTextBlock'
import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from '../Typography/Caption'
import LinePlaneDepartureIcon from '../Icons/line/LinePlaneDepartureIcon'

interface Props extends Utils.PropsWithDataAttributes {
  product: 'hotel' | 'tour'
  price: number | undefined
  /**
   * Appends the price with "/person"
   *
   * Wouldn't have any effect if `price` is not provided.
   */
  pricePerPerson?: boolean
}

function PriceRowFlightPackage(props: Props) {
  const {
    product,
    price,
    pricePerPerson,
    ...rest
  } = props

  const intl = useIntl()

  const formattedPrice = price !== undefined ? (
    <Caption
      as="span"
      variant="medium"
      colour="neutral-one"
      weight="bold"
    >
      <FormatCurrency value={price} format="roundedDollar" />
    </Caption>
  ) : undefined

  const flightsFromPricePerPersonLabel = intl.formatMessage(
    {
      id: 'WmROnot8JI',
      defaultMessage: '{product, select, hotel {Hotel} other {Tour}} + flights from {price}* /person',
      description: 'Flight package price label showing per person price for hotel or tour with flights',
    },
    { product, price: formattedPrice },
  )
  const flightsFromPriceLabel = intl.formatMessage(
    {
      id: 'R0e5zj4SFs',
      defaultMessage: '{product, select, hotel {Hotel} other {Tour}} + flights from {price}*',
      description: 'Flight package price label showing total price for hotel or tour with flights',
    },
    { product, price: formattedPrice },
  )
  const flightsPackageAvailableLabel = intl.formatMessage(
    {
      id: 'UDGJAnMIKy',
      defaultMessage: '{product, select, hotel {Hotel} other {Tour}} + flights package available',
      description: 'Flight package label when price is not yet available',
    },
    { product },
  )

  return <CaptionTextBlock
    {...rest}
    variant="medium"
    colour="neutral-two"
    weight="normal"
    wrap="pre-wrap"
    startIcon={<LinePlaneDepartureIcon />}
  >
    {!!price && pricePerPerson && flightsFromPricePerPersonLabel}
    {!!price && !pricePerPerson && flightsFromPriceLabel}
    {price === undefined && flightsPackageAvailableLabel}
  </CaptionTextBlock>
}

export default PriceRowFlightPackage
